import * as React from "react";
import {observer} from "mobx-react";
import {runInAction} from "mobx";

import "../topic-toggle/topic-toggle.scss";

import {Form, Radio} from "semantic-ui-react";

import {TopicConfiguration} from "../../../config/topic-configuration";
import {TopicToggleConfiguration} from "../../config/topic-toggle-configuration";
import {PathUtils} from "../../../utils/path-utils";
import {IAppStore, withStore} from "../../stores/abstract-app-store";

export interface TopicToggleProps {
    config: TopicToggleConfiguration;
    store?: IAppStore; // this is injected by withStore
}

// TODO:
@observer
class TopicToggleBase extends React.Component<TopicToggleProps, any> {
    widgetKey = "topic-toggle";
    constructor(props: TopicToggleProps) {
        super(props);

        this.setTopic = this.setTopic.bind(this);
    }

    setTopic(topic: TopicConfiguration) {
        runInAction(() => {
            const {store} = this.props;
            if (!store) {
                return;
            }
            // Falls sich das Subtopic ändert, Popup und Tools (z.B. Höhenprofil) schliessen
            if(topic.id !== store.appStore.subtopicId) {
                store.PopupStore.setVisible(false);
                store.uiStore.setActiveTool("");
            }
            store.appStore.setSubtopic(topic);
            store.appStore.setRoutePath(PathUtils.joinPath(store.appStore.topic.routes[0], topic?.routes[0]));
        });
    }

    componentDidMount(): void {
        const {store} = this.props;
        if (store?.uiStore.widgets.has(this.widgetKey)) {
            return;
        }
        store?.uiStore.addWidget(this.widgetKey, this);
    }

    componentWillUnmount(): void {
        const {store} = this.props;
        store?.uiStore.removeWidget(this.widgetKey);
    }

    render(): React.JSX.Element | null {
        const {config, store} = this.props;
        if (!store || !config) {
            return null;
        }

        const {subtopic} = store.appStore;
        // get topics matching the configured topics
        const topics = store.mapViewerConfig.subtopics.filter((st) =>
            config.topics.some((tc) => tc.id === st.id)
        );
        if (!subtopic || !topics) {
            return null;
        }

        // TODO: add other  control types (e.g. select)
        if (config.controlType === "radio") {
            const items = config.topics.map((toggleOption) => {
                const key = `geo-topic-toggle-radio-${toggleOption.id}_${config.id}`;
                const subtopicForThisOption = topics.find((t) => t.id === toggleOption.id);
                if (!subtopicForThisOption) {
                    return;
                }
                return (
                    <Form.Field key={key}>
                        <Radio
                            label={toggleOption.label}
                            name={config.id}
                            value={toggleOption.id}
                            onChange={() => {
                                this.setTopic(subtopicForThisOption);
                            }}
                            checked={subtopic.id === toggleOption.id}
                        />
                    </Form.Field>
                );
            });

            const groupKey = `geo-topic-toggle-option-group-${config.id}`;
            return (
                <div className="geo-topic-toggle">
                    <Form.Group
                        grouped
                        key={groupKey}>
                        <label>{config.label}</label>
                        {items}
                    </Form.Group>
                </div>
            );
        }
        throw new Error(`Topic toggle: Control type not yet implemented ${config.controlType}`);
    }
}

export const TopicToggle = withStore(TopicToggleBase);
